import { ShortVideoContentItemProps } from '@components/report/content-items/short-video-content-item/ShortVideoContentItem';

import { TTReportRes, TTContentData } from '@apis/orval/model';

import { VideoContentTtProps } from './VideoContentTt';

export class VideoContentTtAdapter {
	value: TTReportRes;
	constructor(obj: TTReportRes) {
		this.value = obj;
	}

	get videoContents() {
		return this.value?.content?.recent_contents ?? [];
	}

	sortContents(contents: TTContentData[], sortBy: 'newest' | 'views') {
		if (sortBy === 'newest')
			return contents.sort(
				(a, b) =>
					new Date(b.upload_at ?? 0).getTime() - new Date(a.upload_at ?? 0).getTime(),
			);
		else if (sortBy === 'views')
			return contents.sort((a, b) => (b.view_count ?? 0) - (a.view_count ?? 0));

		return contents;
	}

	getFeedContentItemProps(videoContentData: TTContentData): ShortVideoContentItemProps {
		return {
			outLink: videoContentData.content_link ?? undefined,
			imgSrc: videoContentData.content_img_link ?? undefined,
			viewCount: videoContentData.view_count ?? undefined,
			contentText: videoContentData.description ?? '제목 없음',
			music: `${videoContentData.music?.title}${
				videoContentData.music?.author ? ` - ${videoContentData.music.author}` : ''
			}`,
		};
	}

	adapt(sortBy: 'newest' | 'views'): VideoContentTtProps {
		return {
			items: this.sortContents(this.videoContents, sortBy).map((videoContentData) =>
				this.getFeedContentItemProps(videoContentData),
			),
		};
	}
}
